angular.module('impactx.rfq').controller('RFQListClosedCtrl', ['$scope', '$redirect', 'selectedListItems', RFQListClosedCtrl]);

function RFQListClosedCtrl($scope, $redirect, selectedListItems)
{
    var self = this;

    this.getDetailLink = function() {
        return impactX.isDefined(selectedListItems.getFirstSelectedItem(), "isMultiSupplier.value") ?
            "multirfq/" + selectedListItems.getFirstSelectedId() : "singlerfqbuyer/" + selectedListItems.getFirstSelectedId();
    };

    var buttonDefinition = [
        {label: "details", linkFunction: self.getDetailLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'RFQBuyer'}
    ];

    this.meta = {
        rowTemplate: 'modules/rfq/templates/rfqlistwithprice.row.tmpl.html',
        filtersTemplate: 'modules/rfq/templates/rfqlist.filters.tmpl.html',
        mainAction: {id: "new", link: "#/singlerfqbuyer/0", icon: "mdi-plus"},
        isSelectAble: true,
        ctrl: this,
        endpoint: '/rfq/listclosed',
        id: "rfqlisclosed",
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    };
    this.processStatus = {value: "closed"};
    $scope.$watch(function() {
        return self.processStatus.value;
    }, function(newValue) {
        if(newValue === "offer") {
            $redirect.redirectTo(null, "/rfqlistoffer");
        } else if (newValue === "open") {
            $redirect.redirectTo(null, "/rfqlistopen");
        } else if (newValue === "prep") {
            $redirect.redirectTo(null, "/rfqlistprep");
        }
    });
}